import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback } from 'react';
import { triggerMarkAllReadButtonClicked, triggerNotificationsAPICallFailed, triggerNotificationsAPICallSucceeded, useCreateFireAnalyticsFromTrigger } from '@atlassian/notification-common';
import { RequestReadState } from '@atlassian/notification-common/types';
import { useNotificationStateFilters } from '../../../use-notification-list-filters-store/store';
import { useFilteredNotifications, useNotificationActions } from '../../store';
var useNotificationReadActions = function useNotificationReadActions() {
  var _useNotificationActio = useNotificationActions(),
    _useNotificationActio2 = _slicedToArray(_useNotificationActio, 2),
    actions = _useNotificationActio2[1];
  var _useNotificationState = useNotificationStateFilters(),
    _useNotificationState2 = _slicedToArray(_useNotificationState, 1),
    filters = _useNotificationState2[0];
  var _useFilteredNotificat = useFilteredNotifications(filters),
    _useFilteredNotificat2 = _slicedToArray(_useFilteredNotificat, 1),
    filteredNotifications = _useFilteredNotificat2[0];
  var noFilteredNotifications = filteredNotifications.length === 0;
  var markBulkNotifications = actions.markBulkNotifications,
    markAllNotificationsRead = actions.markAllNotificationsRead,
    disableListFetching = actions.disableListFetching;
  var fireNotificationsAPICallSucceeded = useCreateFireAnalyticsFromTrigger(triggerNotificationsAPICallSucceeded);
  var fireNotificationsAPICallFailed = useCreateFireAnalyticsFromTrigger(triggerNotificationsAPICallFailed);
  var fireTriggerMarkAllRead = useCreateFireAnalyticsFromTrigger(triggerMarkAllReadButtonClicked);
  var handleMarkBulkNotifications = useCallback(function (markNotifications, toState) {
    markBulkNotifications(markNotifications, toState, {
      onSuccess: fireNotificationsAPICallSucceeded,
      onError: fireNotificationsAPICallFailed
    });
  }, [markBulkNotifications, fireNotificationsAPICallSucceeded, fireNotificationsAPICallFailed]);
  var handleMarkAllNotificationsRead = useCallback(function () {
    if (noFilteredNotifications) {
      return;
    }

    // Only disable fetching for the filters with 'UNREAD' read state
    if (filters.readStateFilter === RequestReadState.UNREAD) {
      disableListFetching(filters);
    }
    markAllNotificationsRead({
      onSuccess: fireNotificationsAPICallSucceeded,
      onError: fireNotificationsAPICallFailed
    }, filters);
    fireTriggerMarkAllRead();
  }, [disableListFetching, markAllNotificationsRead, fireTriggerMarkAllRead, fireNotificationsAPICallSucceeded, fireNotificationsAPICallFailed, filters, noFilteredNotifications]);
  return {
    handleMarkBulkNotifications: handleMarkBulkNotifications,
    handleMarkAllNotificationsRead: handleMarkAllNotificationsRead
  };
};
export default useNotificationReadActions;